export default function courseDetailModalController($uibModalInstance, $sce, course) {

    this.course = course;
    this.code = course.subjectCode + course.catalogNumber;
    this.description = $sce.trustAsHtml(course.description);

    this.value = o => o.offered.join(', ');
    this.ok = () => $uibModalInstance.close();
    this.cancel = () => $uibModalInstance.dismiss();
};
